// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT
import { AlertService } from '@app/core/services/alert.service';
import { OnInit } from '@angular/core';
import { RolesFacadeService } from '@app/access-management/state/roles.facade';
import { of, zip } from 'rxjs';
import { readParameterFromRouterState, RolesService, UserService } from '@app/core';
import { ActivatedRoute } from '@angular/router';
import { UserDetailsFacadeService } from '@app/access-management/state/user-details/user-details.facade';
import { map, switchMap } from 'rxjs/operators';
import { RoleScopeFacadeService } from '@app/access-management/state/role-scole.facade';
import { disableMultiSelectRadio, disableSelectAllRadio, isScopeAdmin } from '@app/core/utilities/scopes.helpers';
var UserDetailsRolesTabAddComponent = /** @class */ (function () {
    function UserDetailsRolesTabAddComponent(rolesFacade, userDetailsFacade, roleService, roleScopeFacade, alertService, activatedRoute, userService) {
        var _this = this;
        this.rolesFacade = rolesFacade;
        this.userDetailsFacade = userDetailsFacade;
        this.roleService = roleService;
        this.roleScopeFacade = roleScopeFacade;
        this.alertService = alertService;
        this.activatedRoute = activatedRoute;
        this.userService = userService;
        this.selectedRoles = [];
        this.roleTableColumns = [
            {
                name: 'Role Name',
                prop: 'name',
                flexGrow: 2
            },
            {
                name: 'Users',
                prop: 'numberOfUsers',
                flexGrow: 1
            },
            {
                name: 'Description',
                prop: 'description',
                flexGrow: 2
            }
        ];
        this.constraintsTableColumns = [
            {
                prop: 'name',
                flexGrow: 2
            },
            {
                prop: 'IsParent',
                flexGrow: 2
            }
        ];
        this.categories = [];
        this.constrains$ = of();
        this.categoryRoleObjects = [];
        this.categoryUrls = [];
        this.selectedCategories = [];
        this.selectedConstraints = [];
        this.selectedMultiScopeConstraints = [];
        this.stepOne = true;
        this.stepTwo = false;
        this.categoryDefaultUrl = '/roles/scopes/admin';
        this.useProjectCommitteeHandler = false;
        this.userRolesv2$ = this.getRoles();
        this.username = readParameterFromRouterState(this.activatedRoute, 'username');
        if (!this.username) {
            throw new Error('group id not in route');
        }
        this.userDetailsFacade.initialize(this.username);
        this.user$ = this.userDetailsFacade.user$;
        this.user$.subscribe(function (user) {
            _this.currentUser = user;
        });
        this.rolesFacade.initialize();
        this.roles$ = this.userDetailsFacade.user$.pipe(switchMap(function (user) {
            return _this.rolesFacade.roles$.pipe(map(function (details) { return _this.excludeUserRolesFromRoleList(user, details.data); }));
        }));
        this.roleScopeFacade.initializeCategories();
        this.roleScopeFacade.categories$.subscribe(function (data) { return (_this.categories = data); });
        this.userRoles$ = this.userService.getUserRoles(this.username);
    }
    UserDetailsRolesTabAddComponent.prototype.getRoles = function () {
        return this.roleService.getList();
    };
    UserDetailsRolesTabAddComponent.prototype.excludeUserRolesFromRoleList = function (user, roles) {
        var userRoles = user.roles || [];
        if (!roles) {
            return [];
        }
        return roles.filter(function (role) { return !userRoles.find(function (userRole) { return userRole.id === role.id; }); });
    };
    UserDetailsRolesTabAddComponent.prototype.ngOnInit = function () { };
    UserDetailsRolesTabAddComponent.prototype.onSelectRoles = function (rows) {
        this.selectedRoles = rows;
    };
    UserDetailsRolesTabAddComponent.prototype.onSelectRolev2 = function (row) {
        this.onSelectRows({ selected: [row] });
    };
    UserDetailsRolesTabAddComponent.prototype.onSelectRows = function (rows) {
        if (rows.selected.length > 1) {
            this.alertService.error('Error: Can select only one role.');
            return;
        }
        if (rows.selected.length === 1) {
            this.selectedRoles = rows.selected;
            this.next();
            return;
        }
        this.selectedRoles = rows.selected;
    };
    UserDetailsRolesTabAddComponent.prototype.addRoles = function () {
        var _this = this;
        var roles = this.selectedRoles;
        var requests = roles.map(function (role, index) {
            return _this.roleService.addUsers(role.id, _this.getRoleUserSelections(index));
        });
        zip.apply(void 0, requests.concat([function () {
                var responses = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    responses[_i] = arguments[_i];
                }
                return responses;
            }])).subscribe(function () {
            _this.userDetailsFacade.addUserRolesSucceed(_this.currentUser);
        }, function (err) {
            _this.alertService.error('Error: There was an error adding roles to user');
        });
    };
    UserDetailsRolesTabAddComponent.prototype.selectCategory = function (category, roleId, categoryRef, roleObjectIndex, radioBtnRef, scopeCategoryRef, scopeMultipleRef, roleName, multiSelectRef, selectAllRef) {
        if (category.name.toLowerCase() === 'project|committee') {
            this.useProjectCommitteeHandler = true;
            return;
        }
        else {
            this.useProjectCommitteeHandler = false;
        }
        var selectedCategory = {
            roleId: roleId,
            id: category.id,
            name: category.name,
            selectAll: false
        };
        this.selectedCategories[roleObjectIndex] = selectedCategory;
        if (category && roleId && categoryRef && radioBtnRef && scopeCategoryRef) {
            if (disableMultiSelectRadio(roleName, category.name)) {
                multiSelectRef.hidden = true;
                scopeCategoryRef.hidden = true;
                categoryRef.hidden = false;
                selectAllRef.hidden = false;
            }
            else if (roleId === categoryRef.id && !isScopeAdmin(category.name)) {
                multiSelectRef.hidden = false;
                radioBtnRef.checked = true;
                categoryRef.hidden = false;
                scopeCategoryRef.hidden = false;
                if (disableSelectAllRadio(roleName, category.name)) {
                    selectAllRef.hidden = true;
                }
                else {
                    selectAllRef.hidden = false;
                }
                if (category.name.toLowerCase() === 'project|organization') {
                    this.categoryUrls[roleObjectIndex] = '/roles/scopes/1';
                    scopeMultipleRef.hidden = false;
                }
                else {
                    this.categoryUrls[roleObjectIndex] = '/roles/scopes/' + category.id;
                    scopeMultipleRef.hidden = true;
                }
            }
            else {
                categoryRef.hidden = true;
            }
        }
        this.roleScopeFacade.initializeConstrains(category.id);
        this.constrains$ = this.roleScopeFacade.constrains$;
    };
    UserDetailsRolesTabAddComponent.prototype.onSelectConstraints = function (row, roleObjectIndex) {
        var category = this.selectedCategories[roleObjectIndex];
        if (category && category.name.toLowerCase() === 'organization' && row.selected.length > 1) {
            this.alertService.error('Error: Can select only one organization.');
        }
        else {
            this.selectedConstraints[roleObjectIndex] = row.selected;
        }
    };
    UserDetailsRolesTabAddComponent.prototype.onSelectMultipleConstraints = function (row, roleObjectIndex) {
        if (row.selected.length > 1) {
            this.alertService.error('Error: Can select only one organization.');
        }
        else {
            this.selectedMultiScopeConstraints[roleObjectIndex] = row.selected;
        }
    };
    UserDetailsRolesTabAddComponent.prototype.next = function () {
        var _this = this;
        this.stepOne = false;
        this.stepTwo = true;
        this.resetSelection();
        this.selectedRoles.forEach(function (role, index) {
            _this.categoryRoleObjects.push([]);
            _this.categoryUrls.push(_this.categoryDefaultUrl);
            _this.selectedConstraints.push();
            _this.selectedCategories.push();
            _this.selectedMultiScopeConstraints.push();
            _this.roleService.getRoleObjects(role.id).subscribe(function (data) {
                if (data) {
                    _this.categoryRoleObjects[index] = _this.includeObjectsFromRoleObjectsList(data);
                }
            });
        });
    };
    UserDetailsRolesTabAddComponent.prototype.previous = function () {
        this.stepOne = true;
        this.stepTwo = false;
        this.resetSelection();
    };
    UserDetailsRolesTabAddComponent.prototype.onSelectAll = function (radioBtnEvent, scopeCategoryRef, roleObjectIndex) {
        if (radioBtnEvent.target.checked) {
            scopeCategoryRef.hidden = true;
            var selectedCategory = this.selectedCategories[roleObjectIndex];
            if (selectedCategory) {
                this.selectedCategories[roleObjectIndex].selectAll = true;
            }
        }
    };
    UserDetailsRolesTabAddComponent.prototype.onSelectMultiple = function (radioBtnEvent, scopeCategoryRef, roleObjectIndex) {
        if (radioBtnEvent.target.checked) {
            scopeCategoryRef.hidden = false;
            var selectedCategory = this.selectedCategories[roleObjectIndex];
            if (selectedCategory) {
                this.selectedCategories[roleObjectIndex].selectAll = false;
            }
        }
    };
    UserDetailsRolesTabAddComponent.prototype.resetSelection = function () {
        this.categoryRoleObjects = [];
        this.categoryUrls = [];
        this.selectedConstraints = [];
        this.selectedCategories = [];
        this.selectedMultiScopeConstraints = [];
    };
    UserDetailsRolesTabAddComponent.prototype.getRoleUserSelections = function (index) {
        var categoryId;
        var categoryName;
        var selectedCategory = this.selectedCategories[index];
        if (selectedCategory) {
            categoryId = selectedCategory.id;
            categoryName = selectedCategory.name;
            if (selectedCategory.selectAll) {
                this.selectedConstraints[index] = [];
                this.selectedConstraints[index] = [{ scopeId: '', id: '*', name: '' }];
            }
            else if (categoryName.toLowerCase() === 'project|organization') {
                if (this.selectedMultiScopeConstraints[index].length > 0) {
                    var orgaConstraint_1 = this.selectedMultiScopeConstraints[index][0];
                    this.selectedConstraints[index].map(function (constraint) {
                        constraint.id = constraint.id + '|' + orgaConstraint_1.id;
                    });
                }
            }
        }
        return {
            users: [this.currentUser],
            category: {
                id: categoryId,
                name: categoryName
            },
            constraints: this.selectedConstraints[index]
        };
    };
    UserDetailsRolesTabAddComponent.prototype.includeObjectsFromRoleObjectsList = function (roleObjects) {
        return this.categories.filter(function (scope) { return roleObjects.find(function (object) { return object.object_id === scope.id; }); });
    };
    return UserDetailsRolesTabAddComponent;
}());
export { UserDetailsRolesTabAddComponent };



// WEBPACK FOOTER //
// ./src/app/access-management/users/user-details/user-details-roles-tab-add/user-details-roles-tab-add.component.ts.pre-build-optimizer.js